import React from "react";
import { TabsAlt, Box } from "orcs-design-system";
import { map, capitalize } from "lodash";

export const TENANT_SETTINGS_TABS = {
  BRANDING: "branding",
  GLOBAL_NOTIFICATION: "tenant-announcements",
  TENANT_FEATURE_FLAGS: "tenant-feature-flags",
  API_KEY_MANAGER: "api-key-manager",
};

export const TenantSettingsTabs = () => {
  return (
    <Box mb="r" boxBorder="default" borderTop="none" borderBottom="none">
      <TabsAlt
        tabsList={map(TENANT_SETTINGS_TABS, (tab) => {
          const tabName = capitalize(tab.replace(/-/g, " "));

          return {
            label: tabName,
            path: tab,
          };
        })}
      />
    </Box>
  );
};
